import { validateRadio } from 'validation/validation';

type ValidationPayload = Record<string, unknown> & {
    isConsultationConducted?: unknown;
    transactionByExternalReferrer?: unknown;
    documentLanguage?: unknown;
};

export const validate = (data: ValidationPayload) => ({
    isConsultationConducted: validateRadio(data?.isConsultationConducted),
    transactionByExternalReferrer: validateRadio(data?.transactionByExternalReferrer),
    documentLanguage: validateRadio(data?.documentLanguage),
});
